export const customTracking = ({ schema, data }) => {
  window.tagManager.custom({
    event: 'selfDescribingEvent',
    schema,
    data,
  });
};
